import React from "react";

function Step3(props) {
  if (props.state.currentStep !== 3) {
    return null;
  }
  return (
    <div className="form-group step-form">
      <h5>Terms and Conditions</h5>
      <p
        className="useragreement"
        style={{ overflow: "auto", height: "200px" }}
      >
        Village Book Builders (“Non-Profit”) owns and operates a not-for-profit
        organization whicharranges for mentoring (“mentoring”) of school
        children by volunteer Volunteers. By signing up toprovide mentoring, you
        (“Volunteer”) are entering into a binding agreement with Non-Profit and
        agree toterms and conditions herein.WHEREAS, Volunteer desires to
        provide mentoring services as arranged by Non-Profit, and willgain and
        benefit from being provided such mentoring opportunities; andWHEREAS,
        the parties desire to specify the terms under which such mentoring shall
        beprovided;NOW THEREFORE, in consideration below describe covenants and
        promises between theparties, the receipt and sufficiency of which is
        hereby acknowledged, the parties agree as follows: 1.Mentoring.
        Volunteer shall provide mentoring services as assigned by Non-Profit,
        subject to theterms and requirements of this agreement. Volunteer
        acknowledges and agrees that it shall receive nocompensation of any kind
        for any mentoring provided under this agreement, and Volunteer covenants
        thatit shall not pursue compensation of any kind from the mentored
        student of the family of the mentoredstudent. Volunteer agrees with
        Non-Profit that the education, skill and experience constitute
        compensationsufficient to warrant consideration between the parties.
        2.Standards of Conduct. Volunteer shall maintain the highest standard of
        conduct in allinteractions with students, other volunteers and teachers,
        and any other person they come into contactwith while serving as a
        volunteer with Non-Profit. Volunteer shall not discuss, display, or
        portray lewd,indecent or inappropriate subject, images, or pictures at
        any time. Volunteer shall respect the individualityand privacy of all
        mentored students, and shall treat such students with the highest
        respect. 3.Termination. Non-Profit retains the right to terminate the
        services of Volunteer at any time forany reason or no reason whatsoever.
        This contract constitutes a right to work contract and can beterminated
        by either party at any time and for reason. In the event of any breach
        of this Agreement byVolunteer, this Agreement shall be automatically
        terminated unless Non-Profit notifies Volunteer that theAgreement is
        still in force and effect. 4.Confidentiality. In the course of providing
        mentoring services, Volunteer may acquireconfidential information from
        Non-Profit or from mentored students and/or their families.
        Confidentialinformation includes, but is not limited to, all lists, data
        or information of any kind pertaining to Non-Profit or mentored students
        which is not, at the time it is acquired, generally available to the
        public.Volunteer shall not at any time reveal or use in any fashion such
        confidential information without theprior express permission of the
        party who owns the information. This provision shall continue in
        fullforce and effect after Volunteer ceases to provide mentoring
        services for Non-Profit. Volunteeracknowledges that damages which
        Non-Profit may suffer from a breach of this paragraph are difficult
        orimpossible to determine, but in no way is such information valued at
        less than Five Hundred and 00/100 Dollars ($500.00). This amount
        constitutes a specified amount of minimum damages between the partiesand
        not liquidated damages. In addition, Non-Profit may obtain injunctive
        relief to prevent Volunteerfrom further dissemination of confidential
        information. If Non-Profit is required to take legal actionagainst
        Volunteer as a result of a breach of any of the covenants contained in
        this paragraph 4 or any otherclause contained within this employment
        contract, he or she will be responsible for the reasonableattorney's
        fees accumulated as a result of said breach. 5.Indemnification. Each
        party shall indemnify and holt the other party and its offices, agents,
        andemployees harmless from and against all liabilities, damages, losses,
        actions, or causes of action, costsand expenses, including reasonable
        attorney’s fees if related to the provision of mentoring services
        byVolunteer in this agreement, as well as any claims related to personal
        injury or death arising out of or inany way contributed to by the acts
        or failure to act of the other party, its agents, employees, officers
        orassigns, including, but not limited to, the careless, reckless,
        negligent, wanton or willful conduct ofVolunteer. Volunteer is
        responsible to obtain and maintain its own insurance, and no insurance
        will beprovided by Non-Profit. Non-Profit shall not be liable for any
        acts of Volunteer, regardless of the natureof those acts, the only
        exception being if such acts by Volunteer were part of the day to day
        activities ofhis or her job with Non Profit and no negligence nor
        intentional conduct on the part of Volunteeroccurred. 6.Volunteer.
        Volunteer understands that, as a volunteer, Volunteer will receive no
        compensation orremuneration for services and will not be eligible for
        any employee benefits. Volunteer acknowledges thatthey are not an
        employee. 7.Intellectual Property. Volunteer hereby irrevocably permits,
        authorizes, grants, and licenses toNon-Profit and its affiliates,
        successors, and assigns, and their respective licensees, and the
        employees,officers, directors, and agents of each and all of them
        (“Authorized Persons”): (i) the rights to display,publicly perform,
        exhibit, transmit, broadcast, reproduce, record, photograph, digitize,
        modify, alter, edit,adapt, create derivative works, exploit, sell, rent,
        license, otherwise use, and permit others to use myname, image,
        likeness, and all materials created by or on behalf of Non-Profit that
        incorporate any of theforegoing (“Materials”) in perpetuity throughout
        the universe in any medium or format (now existing orhereafter created),
        without further consent from or compensation to me (and Non-Profit shall
        be theexclusive owner of all rights, including copyright, in the
        Materials); and (ii) the entire right, title, andinterest, in and to the
        Materials and all intellectual property rights in the Materials arising
        in anyjurisdiction throughout the universe in perpetuity, including all
        registration, renewal, and reversion rights,and the right to sue to
        enforce such copyrights against infringers. By agreeing to these terms
        andconditions, Volunteer acknowledges and agrees that Volunteer has no
        right to review or approve Materialsbefore they are used by Non-Profit,
        and that Non-Profit has no liability to me for any editing or
        alterationof the Materials or for any distortion or other effects
        resulting from Non-Profit’s editing, alteration, or useof the Materials,
        or Non-Profit’s presentation of me. Any credit or other acknowledgment
        of me, if any,shall be determined by Non-Profit in Non-Profit’s sole
        discretion. Non-Profit has no obligation to createor use the Materials
        or to exercise any rights given by this Agreement. To the extent
        permitted byapplicable law, Volunteer hereby irrevocably waives all
        legal and equitable rights relating to all liabilities,claims, demands,
        actions, suits, damages, and expenses, including but not limited to
        claims forinfringement, libel, defamation, invasion of any rights of
        privacy (including intrusion, false light, publicdisclosure of private
        facts, and misappropriation of name or likeness), violation of rights of
        publicity,physical or emotional injury or distress, or any similar claim
        or cause of action under any other legaltheory (now known or hereafter
        known) in any jurisdiction worldwide (“Claims”) arising from
        theAuthorized Persons’ exercise of their rights under this Agreement or
        the use of the Materials, and whetherresulting by the negligence of
        Non-Profit or any other person, covenant not to make or bring any
        suchClaim against any Authorized Persons, and forever release and
        discharge the Authorized Persons fromliability under such Claims.
        Volunteer understands Non-Profit is relying on this Agreement and will
        incursignificant expense in its reliance, and Volunteer agrees that this
        Agreement cannot be terminated,rescinded, or modified, in whole or in
        part.8.Entire Agreement. This agreement embodies the entire ”four
        corners” of the agreement betweenthe parties, and replaces any prior
        understandings or discussions of the parties. This Agreement may onlybe
        changed or modified in writing, signed by both parties. 9.Successors and
        Assigns. All of the terms and conditions of this Agreement are binding
        on thesuccessors and assigns of both parties. Volunteer may not assign
        this Agreement or its duties under thisAgreement to any other party,
        without the written consent of Non Profit. Non Profit may not sell
        orassign its rights under this Agreement without the prior written
        consent of Volunteer. 10.Governing Law. This Agreement shall be governed
        by and construed in accordance with thelaws of the State of Utah. Venue
        for any legal action between the parties shall be Utah County,
        Utah.11.Dispute Resolution. In the event of a dispute between the
        parties regarding this Agreement, theparties shall first negotiate in
        good faith to see if such dispute can be resolved. If any claim or
        action isfiled in court by either party respecting this Agreement, the
        prevailing party shall be entitled, in additionto all expenses, costs or
        damages, to reasonable attorneys’ fees, whether or not such controversy
        waslitigated or prosecuted to judgment. 12.Severability. If any term or
        provision of this Agreement shall be held to be invalid orunenforceable,
        the remainder of this Agreement shall not be affected thereby. Each term
        and provision ofthis Agreement shall be valid and enforced to the
        fullest extent permitted by law.13.Notices. Any notice provided for or
        concerning this agreement shall be in writing and be deemedsufficiently
        given when hand delivered or sent by certified or registered mail if
        sent to the respectiveaddress of each party. 14.Headings and Drafting.
        The headings used herein are for purposes of convenience only andshould
        not be used in construing or interpreting the provisions hereof. In all
        questions of interpretation ofthis agreement, the parties shall jointly
        be considered to have been the drafters of the same. ThisAgreement may
        be executed in counterparts. Facsimile signatures of this agreement
        shall be consideredbinding, and the same as original
        signatures.15.Compliance with Law. Each party warrants that all times
        they are and will remain in compliancewith all applicable federal, state
        and local laws pertaining to the services provided for in this
        agreement. Failure to comply with this paragraph by Volunteer or anyone
        under the employment of Volunteer shallresult in the immediate breach of
        this agreement.
      </p>

      <div>
        <label htmlFor="termsCond">
          Do you agree to the Terms and Conditions as explained above?
        </label>
        <select
          name="termsCond"
          id="termsCond"
          value={props.state.termsCond}
          onChange={props.handleChange}
        >
          <option value="No choice">-</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>

      <div>
        <label htmlFor="charged">
          Have you ever been arrested, charged, or convicted of child abuse or
          molestation of any form?
        </label>
        <select
          name="charged"
          id="charged"
          value={props.state.charged}
          onChange={props.handleChange}
        >
          <option value="No choice">-</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>

      <div>
        <label htmlFor="commit">
          Can you commit to being a mentor for a minimum of 4 months?
        </label>
        <select
          name="commit"
          id="commit"
          value={props.state.commit}
          onChange={props.handleChange}
        >
          <option value="No choice">-</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>

      <label htmlFor="initials">
        Do you agree to the above terms and conditions, and to 4-month
        commitment to your mentoring session?
      </label>
      {
        props.adult==="No" ?
        <p>Sign by putting your initials.</p>
        :
        <p>Please have a Parent or Guardian sign by putting their initials.</p>
      }
     
      <input
        className="form-control"
        id="initials"
        name="initials"
        type="text"
        placeholder="Initials - ie 'JTD'"
        value={props.state.initials}
        onChange={props.handleChange}
      />
    </div>
  );
}

export default Step3;
